/* Kroky realitní zakázky + JEDEN typ karty pro celou sekci.
 *
 * PROČ TENHLE SOUBOR:
 *  1) Seznam kroků musí být na jednom místě. Kdyby si ho seznam i karta držely
 *     každý sám, přibude osmý krok jen na jedné obrazovce a makléř uvidí na
 *     každé jinou cestu.
 *  2) Jeden typ karty. Celá sekce používá `KARTA` — žádná druhá varianta se
 *     stínem, žádná s barevnou linkou na hraně.
 *
 * ⚠️ POŘADÍ A POČET MUSÍ SEDĚT NA BACKEND. Server drží fáze v
 * `PRODUCT_FLOWS["prodej_nemovitosti"]` (backend/routes/deals.py) a posílá
 * `stav_index`. Tady se index jen PŘEKLÁDÁ do jazyka makléře — nikdy se z něj
 * nepočítá stav. Hlídá to test `krokyZakazky.test.js`.
 *
 * BARVY: výhradně tokeny motivu (--ink, --muted, --line, --surface, --accent).
 * Aplikace má dva hotové motivy (sage, indigo) a natvrdo zapsaný hex by v jednom
 * z nich vypadal jako cizí prvek.
 */

/** Kroky v pořadí. `k` je přípona klíče do slovníku (`zakazky.faze0`…). */
export const KROKY = [0, 1, 2, 3, 4, 5, 6];
export const POSLEDNI_KROK = KROKY.length - 1;

/** Index → popisek fáze v jazyce makléře. Mimo rozsah spadne na první krok. */
export function nazevKroku(t, index) {
  const i = Math.max(0, Math.min(Number(index) || 0, POSLEDNI_KROK));
  return t(`zakazky.faze${i}`);
}

/** Index → co v téhle fázi udělat. Tohle je ta věta, kvůli které sem makléř chodí. */
export function ukolKroku(t, index) {
  const i = Math.max(0, Math.min(Number(index) || 0, POSLEDNI_KROK));
  return t(`zakazky.ukol${i}`);
}

/* ── Jeden typ karty pro celou sekci ─────────────────────────────────────── */
export const KARTA = {
  background: "var(--surface)",
  border: "1px solid var(--line)",
  borderRadius: 12,
  padding: 18,
};

export const NADPIS_KARTY = {
  fontSize: 13,
  fontWeight: 600,
  color: "var(--ink)",
  margin: 0,
};

export const POPISEK = { fontSize: 12, color: "var(--muted)" };

/** Tlačítko. `hlavni` = primární akce obrazovky, jinak tiché. */
export function tlacitko(hlavni = false, vypnuto = false) {
  return {
    padding: "8px 14px",
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 600,
    cursor: vypnuto ? "not-allowed" : "pointer",
    opacity: vypnuto ? 0.5 : 1,
    border: hlavni ? "1px solid var(--accent)" : "1px solid var(--line)",
    background: hlavni ? "var(--accent)" : "transparent",
    color: hlavni ? "var(--surface)" : "var(--ink)",
  };
}

export const POLE = {
  width: "100%",
  padding: "8px 10px",
  borderRadius: 8,
  border: "1px solid var(--line)",
  background: "var(--bg)",
  color: "var(--ink)",
  fontSize: 14,
};
